export function flattenCountryCodes(regions = []) {
  const codes = [];
  regions.forEach((region) => {
    (region.country_code || []).forEach((item) => {
      if (item.country_code) {
        codes.push(item.country_code);
      }
    });
  });
  return [...new Set(codes)];
}

export function isRegionFullySelected(regionCodes = [], selectedCodes = []) {
  if (!regionCodes.length) {
    return false;
  }
  return regionCodes.every((code) => selectedCodes.includes(code));
}

export function toggleRegionCountries(regionCodes = [], selectedCodes = []) {
  if (isRegionFullySelected(regionCodes, selectedCodes)) {
    return selectedCodes.filter((code) => !regionCodes.includes(code));
  }
  return [...new Set([...selectedCodes, ...regionCodes])];
}

export function getRegionCountryLabels(region = {}) {
  return (region.country_code || [])
    .map((item) => item.country_name || item.country_code)
    .filter(Boolean);
}

/** 对齐原型 HTML regionData[].name */
export const INTL_REGION_DISPLAY_NAME = {
  JKT: "日韩港澳台",
  NA_EU_ANZ: "北美/欧洲/澳新",
  CIS: "东欧/中亚",
  LATAM: "拉美",
  SESA: "南亚/东南亚",
  MENA: "中东/非洲",
};

/** 对齐原型 HTML regionData[].desc（固定文案，非算法拼接） */
export const INTL_REGION_UNSELECTED_DESC = {
  JKT: "日本,韩国,中国港澳台",
  NA_EU_ANZ: "美国,英国,德国等",
  CIS: "俄罗斯,乌克兰等",
  LATAM: "巴西,墨西哥,阿根廷等",
  SESA: "印度,印尼,泰国等",
  MENA: "沙特,土耳其,埃及等",
};

export function getRegionDisplayName(region = {}) {
  return INTL_REGION_DISPLAY_NAME[region.region_code] || region.region_name || region.region_code;
}

export function getRegionUnselectedDesc(region = {}) {
  const mapped = INTL_REGION_UNSELECTED_DESC[region.region_code];
  if (mapped) {
    return mapped;
  }
  const labels = getRegionCountryLabels(region);
  if (!labels.length) {
    return "暂无国家数据";
  }
  return labels.join(",");
}

/** 对齐原型：未选 reg.desc / 已全选 / 已选: a, b, c */
export function getRegionCardSummary(region = {}, selectedLabels = []) {
  const allLabels = getRegionCountryLabels(region);
  if (!allLabels.length) {
    return "暂无国家数据";
  }
  if (!selectedLabels.length) {
    return getRegionUnselectedDesc(region);
  }
  if (selectedLabels.length === allLabels.length) {
    return "已全选";
  }
  return `已选: ${selectedLabels.join(", ")}`;
}

export function inferRegionStateFromDetail(detail = {}, regionOptions = []) {
  const allCountryCodes = flattenCountryCodes(regionOptions);
  const saved = Array.isArray(detail.white_list_region) ? detail.white_list_region : [];

  if (!saved.length) {
    return {
      mode: "global",
      selectedCountryCodes: [],
      allCountryCodes,
    };
  }

  const savedSet = new Set(saved);
  const isGlobal =
    allCountryCodes.length > 0 &&
    saved.length === allCountryCodes.length &&
    allCountryCodes.every((code) => savedSet.has(code));

  if (isGlobal) {
    return {
      mode: "global",
      selectedCountryCodes: [...allCountryCodes],
      allCountryCodes,
    };
  }

  return {
    mode: "custom",
    selectedCountryCodes: saved.filter((code) => allCountryCodes.includes(code)),
    allCountryCodes,
  };
}

export function buildWhiteListRegion({ mode, selectedCountryCodes, allCountryCodes }) {
  if (mode === "global") {
    return [...allCountryCodes];
  }
  return [...selectedCountryCodes];
}

export function validateRegionSelection({ mode, selectedCountryCodes, allCountryCodes }) {
  if (mode === "global") {
    if (!allCountryCodes.length) {
      return "地区枚举为空，无法保存";
    }
    return null;
  }
  if (!selectedCountryCodes.length) {
    return "指定区域模式下请至少选择一个国家/地区";
  }
  return null;
}

export function isFirstCompleteSave(detailMeta = {}) {
  return !Array.isArray(detailMeta.white_list_region) || !detailMeta.white_list_region.length;
}
